export default {
  "комплексні обіди з 12:00 до 15:00": {
    1: {
      name: "Понеділок",
      photo: "complex/1.jpeg",
      desc: "салат з буряка, пюре, запечена куряча грудинка під соусом, компот-узвар, борщ, бородинський хліб",
      storage:
        "салат з буряка, пюре, запечена куряча грудинка під соусом, компот-узвар, борщ, бородинський хліб",
      price: "180 UAH",
      weight: "1200г",
      categoria: "комплексні обіди з 12:00 до 15:00",
      id: 1,
    },
    2: {
      name: "Вівторок",
      photo: "complex/2.jpeg",
      desc: "Картопля по селянськи, маринований огірок, морква по корейськи, ковбаска, бульйон, компот-узвар, бородинський хліб",
      storage:
        "Картопля по селянськи, маринований огірок, морква по корейськи, ковбаска, бульйон, компот-узвар, бородинський хліб",
      price: "180 UAH",
      weight: "900г",
      categoria: "комплексні обіди з 12:00 до 15:00",
      id: 2,
    },
    3: {
      name: "Середа",
      photo: "complex/3.jpeg",
      desc: "олів'є, паста карбонара, грибний крем суп, компот-узвар, бородинський хліб",
      storage:
        "олів'є, паста карбонара, грибний крем суп, компот-узвар, бородинський хліб",
      price: "180 UAH",
      weight: "1000г",
      categoria: "комплексні обіди з 12:00 до 15:00",
      id: 3,
    },
    4: {
      name: "Четвер",
      photo: "complex/4.jpeg",
      desc: "Жарена картопля з беконом, курячий шашлик, салат з огірків та помідорів, борщ, компот-узвар, бородинський хліб",
      storage:
        "Жарена картопля з беконом, курячий шашлик, салат з огірків та помідорів, борщ, компот-узвар, бородинський хліб",
      price: "180 UAH",
      weight: "1100г",
      categoria: "комплексні обіди з 12:00 до 15:00",
      id: 4,
    },
    5: {
      name: "П'ятниця",
      photo: "complex/5.jpeg",
      desc: "картопляні діпи, курячий стейк, бульйон, часниковий соус, салат з капусти, компот-узвар, бородинський хліб",
      storage:
        "картопляні діпи, курячий стейк, бульйон, часниковий соус, салат з капусти, компот-узвар, бородинський хліб",
      price: "180 UAH",
      weight: "1100г",
      categoria: "комплексні обіди з 12:00 до 15:00",
      id: 5,
    },
  },
  Сніданки: {
    // 1: {
    //   name: "Спаржа з камамбером",
    //   photo: "snidanok/6.JPG",
    //   desc: "",
    //   storage:
    //     "Спаржа, Камамбер, Чері, Тим`ян, часник, соус песто, мікс салату, Мигдальні пластівці",
    //   price: "240 UAH",
    //   weight: "252г",
    //   categoria: "Сніданки",
    //   id: 1,
    // },
    // 2: {
    //   name: "Спаржа з креветками",
    //   photo: "snidanok/7.JPG",
    //   desc: "",
    //   storage:
    //     "Спаржа, Тигрова креветка, Тим'ян, часник, яйця, Майонез-васабі, кунжут, Соус чедер, цибуля кріспі, мікс салату",
    //   price: "250 UAH",
    //   weight: "280г",
    //   categoria: "Сніданки",
    //   id: 2,
    // },
    // 3: {
    //   name: "Спаржа з яйцем пашот та беконом",
    //   photo: "snidanok/5.jpg",
    //   desc: "",
    //   storage:
    //     "Спаржа, часник, Тим'ян, яйця, бекон, Чіабата, сир чедер, кунжут, мікс салату",
    //   price: "195 UAH",
    //   weight: "300г",
    //   categoria: "Сніданки",
    //   id: 3,
    // },
    4: {
      name: "Сніданок Легкий",
      photo: "snidanok/5.png",
      desc: "До сніданка дається гарячий напій ( кава чи чай на вибір )",
      storage:
        "Куряче філе, яйце, крем сир, чіабата, мікс салату, томати чері, кіноа, соус гірчичний",
      price: "180 UAH",
      weight: "300г",
      categoria: "Сніданки",
      id: 4,
    },
    5: {
      name: "Сніданок Моцний",
      photo: "snidanok/8.jpg",
      desc: "До сніданка дається гарячий напій ( кава чи чай на вибір )",
      storage:
        "Яйце куряче, помідор, стручкова фасоля, хліб зерновий, ковбаски курячі",
      price: "190 UAH",
      weight: "350г",
      categoria: "Сніданки",
      id: 5,
    },
    6: {
      name: "Тост із лососем та авокадо",
      photo: "snidanok/3.jpg",
      desc: "До сніданка дається гарячий напій ( кава чи чай на вибір )",
      storage:
        "Соус чедер, яйце, кунжут, авокадо, лосось, мікс салату, тостовий хліб",
      price: "250 UAH",
      weight: "245г",
      categoria: "Сніданки",
      id: 6,
    },
    7: {
      name: "Тост із беконом та авокадо",
      photo: "snidanok/4.jpg",
      desc: "До сніданка дається гарячий напій ( кава чи чай на вибір )",
      storage:
        "крем сир, соус чедер, яйце, авокадо, мікс салату, хліб тостовий, бекон, паприка копчена, цибуля кріспі",
      price: "195 UAH",
      weight: "255г",
      categoria: "Сніданки",
      id: 7,
    },
  },
  Салати: {
    1: {
      name: "Олів'є",
      photo: "salats/1.JPG",
      desc: "Стандартний всім любимий салат 'Олів'є' нікого не залишить байдужими",
      storage:
        "картопля, морква, горошок, запечене куряче філе, цибуля ріпч., яйця, майонез Айолі, огірок маринований ",
      price: "145 UAH",
      weight: "250г",
      categoria: "Салати",
      id: 1,
    },
    2: {
      name: "Оселедець під Шубою",
      photo: "salats/2.jpg",
      desc: "",
      storage:
        "оселедець, майонез Айолі, картопля, морква, цибуля, буряк, яйця перепилині",
      price: "125 UAH",
      weight: "260г",
      categoria: "Салати",
      id: 2,
    },
    3: {
      name: "Цезар",
      photo: "salats/12.jpeg",
      desc: "",
      storage:
        "запечене куряче філе, бекон, листя салату, айсберг, соус цезар, яйця перепелині, пармезан, чері, чіабата",
      price: "175 UAH",
      weight: "230г",
      categoria: "Салати",
      id: 3,
    },
    4: {
      name: "Салат від шефа",
      photo: "salats/4.jpg",
      desc: "Салат від шефа з запеченими баклажанами та сиром халумі",
      storage:
        "баклажан, помідор, цибуля кримська, базилік, соус світ чилі, Сир халумі",
      price: "240 UAH",
      weight: "325г",
      categoria: "Салати",
      id: 4,
    },
    // 5: {
    //   name: "Салат з тюлькою по одеськи",
    //   photo: "salats/5.jpg",
    //   desc: "",
    //   storage:
    //     "картопля, огірок, яйця перепелині, бринза, зелена цибуля, тюлька, фірмовий дресінг",
    //   price: "145 UAH",
    //   weight: "300г",
    //   categoria: "Салати",
    //   id: 5,
    // },
    // 6: {
    //   name: "Теплий салат зі свининою та дор блю",
    //   photo: "salats/6.jpg",
    //   desc: "",
    //   storage:
    //     "стручкова квасоля, сир дор блю, Чері,соєвий соус, айсберг, листя салату, мікс салат, Мікрогріни, соус бальзамічний, Свинна вирізка, Рукола",
    //   price: "210 UAH",
    //   weight: "300г",
    //   categoria: "Салати",
    //   id: 6,
    // },
    7: {
      name: "Салат з прошутто та томленою грушею",
      photo: "salats/7.jpg",
      desc: "",
      storage:
        "листя салату, Помідор, груша глінтвейн, грецький горіх, Прошутто",
      price: "175 UAH",
      weight: "225г",
      categoria: "Салати",
      id: 7,
    },
    // 8: {
    //   name: "Салат з ростбіфом та лисичками",
    //   photo: "salats/8.jpg",
    //   desc: "",
    //   storage:
    //     "листя салату, каперси, лисички, ростбіф, Будз копчений, соус бальзамічний",
    //   price: "155 UAH",
    //   weight: "200г",
    //   categoria: "Салати",
    //   id: 8,
    // },
    // 9: {
    //   name: "Салат з авокадо та креветками по Одеськи",
    //   photo: "salats/9.jpg",
    //   desc: "",
    //   storage:
    //     "Соус Вінігред, листя салату, руколла, чері, авокадо, тигрові креветки, кунжут",
    //   price: "250 UAH",
    //   weight: "210г",
    //   categoria: "Салати",
    //   id: 9,
    // },
    // 10: {
    //   name: "Салат від тети Соні",
    //   photo: "salats/10.jpg",
    //   desc: "",
    //   storage:
    //     "буряк, огірок маринований, Сир фета, Рукола, грецький горіх, груша, соус порто",
    //   price: "90 UAH",
    //   weight: "220г",
    //   categoria: "Салати",
    //   id: 10,
    // },
    11: {
      name: "Цезар з тигровими креветками",
      photo: "salats/11.jpg",
      desc: "",
      storage:
        "салат айсберг, листя салату, соус цезар, креветка тигрова, бекон, яйце перепелине, томат чері, пармезан.",
      price: "215 UAH",
      weight: "250г",
      categoria: "Салати",
      id: 11,
    },
  },
  "Перші страви": {
    1: {
      name: "Борщ на ребрі зі сметаною",
      photo: "firstEat/7.jpeg",
      desc: "",
      storage:
        "Хліб бородінський, сметана, цибуля кримська, часник, зелена цибуля, петрушка, Борщ, Сало з паприкою",
      price: "125 UAH",
      weight: "453г",
      categoria: "Перші страви",
      id: 1,
    },
    2: {
      name: "Гарбузовий крем-суп",
      photo: "firstEat/8.jpeg",
      desc: "",
      storage: "Гарбуз,бекон, пармезан, вершки,масло,сир янтар",
      price: "130 UAH",
      weight: "300г",
      categoria: "Перші страви",
      id: 2,
    },
    3: {
      name: "Курячий бульйон",
      photo: "firstEat/3.JPG",
      desc: "",
      storage:
        "Бульйон курячий, яйця перепелині, бройлер, кріп, локшина, морква",
      price: "85 UAH",
      weight: "300г",
      categoria: "Перші страви",
      id: 3,
    },
    // 4: {
    //   name: "Вершково - рибний суп",
    //   photo: "firstEat/4.jpg",
    //   desc: "",
    //   storage: "рибний бульйон, морква, картопля, корінь селери, зелень",
    //   price: "150 UAH",
    //   weight: "450г",
    //   categoria: "Перші страви",
    //   id: 4,
    // },
    // 5: {
    //   name: "Том Ям по-одеськи",
    //   photo: "firstEat/5.jpeg",
    //   desc: "",
    //   storage:
    //     "Суп на основі курячого бульйону з додаванням вершків,тигрових креветок,відварної курки,шампанйоні,цибулі порей,лемонграсу,пікантної пасти Том Ям,подається з рисом.",
    //   price: "190 UAH",
    //   weight: "500г",
    //   categoria: "Перші страви",
    //   id: 5,
    // },
  },
  Брускети: {
    1: {
      name: "Брускети з авокадо",
      photo: "bruskets/1.jpeg",
      desc: "",
      storage:
        "крем сир, авокадо, Чері, крем бальзамічний, оливки чорні, Рукола",
      price: "170 UAH",
      weight: "189г",
      categoria: "Брускети",
      id: 1,
    },
    2: {
      name: "Брускети з лососем",
      photo: "bruskets/6.jpg",
      desc: "",
      storage:
        "лосось, крем сир, огірок, оливки чорні, крем бальзамічний, Рукола",
      price: "190 UAH",
      weight: "194г",
      categoria: "Брускети",
      id: 2,
    },
    3: {
      name: "Тюлька на бородинському хлібі",
      photo: "bruskets/3.jpeg",
      desc: "",
      storage:
        "Хліб бородінський, Помідор, зелень, Гірчиця в зернах, цибуля кримська, олія соняшникова, лимон, перець, масло, тюлька",
      price: "95 UAH",
      weight: "242г",
      categoria: "Брускети",
      id: 3,
    },
    4: {
      name: "Брускети з прошутто та карамелізованою грушею",
      photo: "bruskets/7.jpeg",
      desc: "",
      storage:
        "Прошутто, крем сир, груша карамелізована, Малиновий джем, Рукола",
      price: "170 UAH",
      weight: "175г",
      categoria: "Брускети",
      id: 4,
    },
    // 5: {
    //   name: "Брускети з розтбіфом та запеченими томатами",
    //   photo: "bruskets/5.jpeg",
    //   desc: "",
    //   storage:
    //     "соус ранч, ростбіф, томати чері запечені, Будз копчений, каперси, мікс салат",
    //   price: "180 UAH",
    //   weight: "205г",
    //   categoria: "Брускети",
    //   id: 5,
    // },
    6: {
      name: "Сет брускет",
      photo: "for_companies/5.jpg",
      desc: "",
      storage:
        "Брускети з авокадо, Брускети з лососем, Брускети з прошутто та карамелізованою грушею",
      price: "395 UAH",
      weight: "590г",
      categoria: "Для компанії",
      id: 6,
    },
  },
  Закуски: {
    1: {
      name: "Запечений камамбер з ягідним соусом",
      photo: "coldEat/15.jpeg",
      desc: "",
      storage:
        "Камамбер, соус ягідний, олія з часником, ківі, прованські трави, паприка",
      price: "220 UAH",
      weight: "490г",
      categoria: "Закуски",
      id: 1,
    },
    2: {
      name: "Моцарелла фрі",
      photo: "coldEat/mozarella.JPG",
      desc: "",
      storage: "моцарелла фрі, соус солодкий чилі",
      price: "145 UAH",
      weight: "200г",
      categoria: "Закуски",
      id: 2,
    },
    // 3: {
    //   name: "Паштет з курячої печінки та цибулі",
    //   photo: "coldEat/kyrPaschtet.jpg",
    //   desc: "",
    //   storage: "",
    //   price: "100 UAH",
    //   weight: "245г",
    //   categoria: "Закуски",
    //   id: 3,
    // },
    4: {
      name: "Сет одеських спеціалітетів",
      photo: "coldEat/setOdes.jpg",
      desc: "",
      storage: "паштет з мідій, паштет з скумбрії, фаршмак",
      price: "200 UAH",
      weight: "410г",
      categoria: "Закуски",
      id: 4,
    },
    5: {
      name: "Сирна забаганка",
      photo: "coldEat/sirnaZabaganka.JPG",
      desc: "",
      storage:
        "Камамбер, кульки філадельфії фрі, сир косичка, сир в халапеньйо, моцарелла фрі, малиновий соус",
      price: "340 UAH",
      weight: "480г",
      categoria: "Закуски",
      id: 5,
    },
    // 6: {
    //   name: "Тар-тар з лосося та авокадо на подушці з крем-сиру",
    //   photo: "coldEat/tartar.jpg",
    //   desc: "",
    //   storage:
    //     "лосось, авокадо, каперси, кримська цибуля, сицилійський соус, устричний соус, сік лимона, ікра червона, мікрогрін, крем-сир, грінки",
    //   price: "255 UAH",
    //   weight: "329г",
    //   categoria: "Закуски",
    //   id: 6,
    // },
    7: {
      name: "Тюлька з картоплею",
      photo: "coldEat/tylkaIzKartoplya.JPG",
      desc: "",
      storage: "Тюлька, картопля, цибуля, гірчичний соус",
      price: "120 UAH",
      weight: "460г",
      categoria: "Закуски",
      id: 7,
    },
    8: {
      name: "Форшмак",
      photo: "coldEat/11.jpg",
      desc: "",
      storage:
        "Оселедець, цибуля, яблуко, сир янтарний, масло, грінки, перепилині яйця",
      price: "95 UAH",
      weight: "205г",
      categoria: "Закуски",
      id: 8,
    },
    // 10: {
    //   name: "Тар-тар з яловичини та мусом з авокадо",
    //   photo: "coldEat/10.jpg",
    //   desc: "",
    //   storage:
    //     "телятина полядвиця, каперси, цибуля кримська, яйця перепилині, корнішон маринований, крем авокадо, оцет бальзамічний, рукола, чіабата, крем бальзамічний",
    //   price: "390 UAH",
    //   weight: "410г",
    //   categoria: "Закуски",
    //   id: 10,
    // },
    11: {
      name: "Плато сиров'ялених закусок",
      photo: "for_companies/4.jpg",
      desc: "",
      storage: "чорізо, фует, Прошуто, крекер, оливки чорні, Мікрогріни",
      price: "250 UAH",
      weight: "135г",
      categoria: "Закуски",
      id: 11,
    },
    12: {
      name: "Сирне плато",
      photo: "for_companies/6.jpg",
      desc: "",
      storage:
        "пармезан, Будз копчений, гауда з чилі, грісіні, Малиновий джем, мед, грецький горіх",
      price: "285 UAH",
      weight: "235г",
      categoria: "Закуски",
      id: 12,
    },
    13: {
      name: "Сало зі спеціями",
      photo: "coldEat/12.jpg",
      desc: "",
      storage: "сало, часник, цибуля, грінки",
      price: "65 UAH",
      weight: "100г",
      categoria: "Закуски",
      id: 13,
    },
    14: {
      name: "Тар-тар з яловичини",
      photo: "coldEat/14.jpg",
      desc: "",
      storage:
        "яловичина, яйце куряче(жовток), цибуля, масло, спеції, соус горчестер, соус табаско, соус соєвий, гірчиця американська, грінки",
      price: "390 UAH",
      weight: "438г",
      categoria: "Закуски",
      id: 14,
    },
  },
  "Закуски до пива": {
    // 1: {
    //   name: "Креветки 'рачки'",
    //   photo: "hotEat/rachki.jpg",
    //   desc: "",
    //   storage: "",
    //   price: "96 UAH",
    //   weight: "113г",
    //   categoria: "Закуски до пива",
    //   id: 1,
    // },
    2: {
      name: "Крильця фрі в бальзамічному соусі з кунжутом",
      photo: "hotEat/krila.jpg",
      desc: "",
      storage: "крильця фрі, соус 'бальзамічний', кунжут",
      price: "150 UAH",
      weight: "360г",
      categoria: "Закуски до пива",
      id: 2,
    },
    3: {
      name: "Пивна дошка фрі",
      photo: "hotEat/pivna.jpg",
      desc: "",
      storage:
        "печериці фрі, арахіс, сир косичка, цибулеві кільця, курячі нагетси, мисливські ковбаски, соус 'BBQ', соус 'часниковий', чіпси з лаваша",
      price: "320 UAH",
      weight: "533г",
      categoria: "Закуски до пива",
      id: 3,
    },
    4: {
      name: "Арахіс із спеціями",
      photo: "hotEat/5.jpg",
      desc: "",
      storage: "",
      price: "30 UAH",
      weight: "50г",
      categoria: "Закуски до пива",
      id: 4,
    },
    5: {
      name: "Хрустка цаца",
      photo: "hotEat/4.jpg",
      desc: "",
      storage: "",
      price: "70 UAH",
      weight: "160г",
      categoria: "Закуски до пива",
      id: 5,
    },
  },
  "Одеські делікатеси": {
    1: {
      name: "Барабуля",
      photo: "odesa/1.jpg",
      desc: "",
      storage: "",
      price: "190 UAH",
      weight: "200г",
      categoria: "Одеські делікатеси",
      id: 1,
    },
    2: {
      name: "Великий казанок мідій в мушлі у вершково-устричному соусі",
      photo: "odesa/2.jpg",
      desc: "",
      storage:
        "вершки, тим'ян, Соус устричний, соєвий соус, лимон, Чіабата, Мідії ракушка",
      price: "495 UAH",
      weight: "900г",
      categoria: "Одеські делікатеси",
      id: 2,
    },
    3: {
      name: "Малий казанок мідій в мушлі у вершково-устричному соусі",
      photo: "odesa/3.jpg",
      desc: "",
      storage:
        "вершки, Тим'ян, Соус устричний, соєвий соус, лимон, Чіабата, Мідії ракушка",
      price: "200 UAH",
      weight: "320г",
      categoria: "Одеські делікатеси",
      id: 3,
    },
    4: {
      name: "Мідії запечені з овочами та крем-сиром",
      photo: "odesa/4.JPG",
      desc: "",
      storage:
        "мідії, печериці, Брокколі, горошок, сир крем, цибуля кримська, кабачок, часник, Тим'ян, Соус устричний",
      price: "185 UAH",
      weight: "360г",
      categoria: "Одеські делікатеси",
      id: 4,
    },
    5: {
      name: "Авторський жульєн рапани з мідіями у вершково часниковому соусі",
      photo: "odesa/5.JPG",
      desc: "",
      storage:
        "мідії, Рапани, цибуля ріпчаста, вершки, соус часниковий, зелень,",
      price: "195 UAH",
      weight: "200г",
      categoria: "Одеські делікатеси",
      id: 5,
    },
    6: {
      name: "Тигрові креветки в хрусткій паніровці",
      photo: "odesa/8.jpg",
      desc: "",
      storage: "Тигрова креветка, кляр, ікорний соус, лимон",
      price: "300 UAH",
      weight: "270г",
      categoria: "Одеські делікатеси",
      id: 6,
    },
    // 7: {
    //   name: "Креветки в бальзамічному соусі",
    //   photo: "odesa/7.jpg",
    //   desc: "",
    //   storage:
    //     "креветка тигрова, соус бальзамічний, часник, лимон, розмарин, тим'ян",
    //   price: "300 UAH",
    //   weight: "220г",
    //   categoria: "Одеські делікатеси",
    //   id: 7,
    // },
    8: {
      name: "Дошка чорноморської риби",
      photo: "for_companies/1.jpg",
      desc: "",
      storage: "барабуля, ферина, лимон, Тим'ян, Бичок",
      price: "430 UAH",
      weight: "650г",
      categoria: "Одеські делікатеси",
      id: 8,
    },
    9: {
      name: "Плато морепродуктів",
      photo: "for_companies/2.JPG",
      desc: "",
      storage:
        "кальмар, Восьминіг, Лангустін, Мідії в вершково-устричному соусі, Тигрова креветка, соєвий соус, масло, Тим'ян, часник, ікорний соус, лимон, Рапани, картопляні діпи	",
      price: "880 UAH",
      weight: "800г",
      categoria: "Одеські делікатеси",
      id: 9,
    },
    10: {
      name: "Запечений фермерський сом в казанку",
      photo: "main/3.jpg",
      desc: "",
      storage:
        "сом філе, стручкова квасоля, кукурудза зерна, масло, вершки 18%, деміглас, соєвий соус, Тим'ян, сир моцарелла, Чіабата",
      price: "190 UAH",
      weight: "326г",
      categoria: "Одеські делікатеси",
      id: 10,
    },
    11: {
      name: "Філе форелі з рисом та овочами",
      photo: "main/28.jpeg",
      desc: "",
      storage: "Апельсин рис горошок масло форель",
      price: "370 UAH",
      weight: "500г",
      categoria: "Одеські делікатеси",
      id: 11,
    },
    12: {
      name: "Форель запечена",
      photo: "main/27.jpeg",
      desc: "",
      storage:
        "Апельсин, цибуля, ріпчаста вершки, ТріплСек, білі гриби, форель",
      price: "350 UAH",
      weight: "600г",
      categoria: "Одеські делікатеси",
      id: 12,
    },
    13: {
      name: "філе лосося з гороховим пюре",
      photo: "main/29.jpeg",
      desc: "",
      storage:
        "Лосось, Горох, Бекон, Цибуля ріпчаста, Вершки, Сіль, Перець, Олія, Соєвий, Чері, Мікс салату, Соус Чедер",
      price: "440 UAH",
      weight: "300г",
      categoria: "Одеські делікатеси",
      id: 13,
    },
    15: {
      name: "Хрустка цаца",
      photo: "hotEat/4.jpg",
      desc: "",
      storage: "",
      price: "70 UAH",
      weight: "160г",
      categoria: "Одеські делікатеси",
      id: 15,
    },
    16: {
      name: "Форшмак",
      photo: "coldEat/11.jpg",
      desc: "",
      storage:
        "Оселедець, цибуля, яблуко, сир янтарний, масло, грінки, перепилині яйця",
      price: "95 UAH",
      weight: "205г",
      categoria: "Одеські делікатеси",
      id: 16,
    },
    17: {
      name: "Тюлька з картоплею",
      photo: "coldEat/tylkaIzKartoplya.JPG",
      desc: "",
      storage: "Тюлька, картопля, цибуля, гірчичний соус",
      price: "120 UAH",
      weight: "460г",
      categoria: "Одеські делікатеси",
      id: 17,
    },
  },
  "Основні страви": {
    1: {
      name: "Паста Карбонара",
      photo: "main/14.jpg",
      desc: "",
      storage:
        "Паста з твердих сортів пшениці, бекон, вершки, пармезан, перепилине яйце",
      price: "160 UAH",
      weight: "350г",
      categoria: "Основні страви",
      id: 1,
    },
    2: {
      name: "Паста з чорнила каракатиці та морепродуктами",
      photo: "main/6.jpg",
      desc: "",
      storage:
        "Спагетті, вершки 18%, мідії, Тигрова креветка, часник, Тим'ян, пармезан, соєвий соус, Соус устричний, Восьминіг,Вино н/с біле",
      price: "290 UAH",
      weight: "300г",
      categoria: "Основні страви",
      id: 2,
    },
    3: {
      name: "Паста з куркою та грибами",
      photo: "main/19.jpg",
      desc: "",
      storage:
        "паста з твердих сортів пшениці, куряче філе, печериці, вершки, пармезан, спеції",
      price: "160 UAH",
      weight: "400г",
      categoria: "Основні страви",
      id: 3,
    },
    // 4: {
    //   name: "Паста Болоньєзе",
    //   photo: "main/20.jpg",
    //   desc: "",
    //   storage:
    //     "паста з твердих сорів пшениці, фарш яловичий, томатна паста, спеції",
    //   price: "160 UAH",
    //   weight: "345г",
    //   categoria: "Основні страви",
    //   id: 4,
    // },
    5: {
      name: "Запечений фермерський сом в казанку",
      photo: "main/3.jpg",
      desc: "",
      storage:
        "сом філе, стручкова квасоля, кукурудза зерна, масло, вершки 18%, деміглас, соєвий соус, Тим'ян, сир моцарелла, Чіабата",
      price: "190 UAH",
      weight: "326г",
      categoria: "Основні страви",
      id: 5,
    },
    6: {
      name: "філе лосося з гороховим пюре",
      photo: "main/29.jpeg",
      desc: "",
      storage:
        "Лосось, Горох, Бекон, Цибуля ріпчаста, Вершки, Сіль, Перець, Олія, Соєвий, Чері, Мікс салату, Соус Чедер",
      price: "440 UAH",
      weight: "300г",
      categoria: "Основні страви",
      id: 6,
    },
    7: {
      name: "Картопелька по домашньому зі свинною ковбаскою",
      photo: "main/21.jpg",
      desc: "",
      storage:
        "ковбаска свинна, картопля ,цибуля ріпчаста , огірок маринований , гірчиця американська",
      price: "150 UAH",
      weight: "440г",
      categoria: "Основні страви",
      id: 7,
    },
    // 8: {
    //   name: "Капуста тушена з мисливськими ковбасками",
    //   photo: "main/23.jpg",
    //   desc: "",
    //   storage: "капуста тушена,  ковбаски мисливські, борошно кукурудзяне",
    //   price: "130 UAH",
    //   weight: "350г",
    //   categoria: "Основні страви",
    //   id: 8,
    // },
    9: {
      name: "Картопляний гратен та ковбаски фламбе",
      photo: "main/26.jpg",
      desc: "",
      storage: "кабаноси, соус ранч, картопля, сметана, сир моцарелла",
      price: "215 UAH",
      weight: "475г",
      categoria: "Основні страви",
      id: 9,
    },
    10: {
      name: "Куряча грудинка у вершковому соусі",
      photo: "main/4.jpg",
      desc: "",
      storage:
        "сир моцарелла, вершки 18%, Брокколі, суміш спецій, Бульйон курячий, Чері, Базилік, Куряче філе",
      price: "185 UAH",
      weight: "364г",
      categoria: "Основні страви",
      id: 10,
    },
    11: {
      name: "Лаваш з запеченою курячою грудинкою",
      photo: "main/18.jpeg",
      desc: "",
      storage:
        "Лаваш, курка гриль, Помідор, огірок маринований, сир моцарелла, соус часниковий, айсберг, цибуля кримська",
      price: "165 UAH",
      weight: "240г",
      categoria: "Основні страви",
      id: 11,
    },
    12: {
      name: "Бефстроганов з білими грибами та картопляним пюре",
      photo: "main/1.JPG",
      desc: "",
      storage:
        "цибуля ріпчаста, білі гриби, вершки 18%, соєвий соус, Телятина, Пюре картопляне",
      price: "320 UAH",
      weight: "385г",
      categoria: "Основні страви",
      id: 12,
    },
    // 13: {
    //   name: "Банош з бринзою та беконом",
    //   photo: "main/22.jpg",
    //   desc: "",
    //   storage:
    //     "крупа кукурудзяна, масло, вершки, будз копчений, пармезан, бекон",
    //   price: "140 UAH",
    //   weight: "367г",
    //   categoria: "Основні страви",
    //   id: 13,
    // },
    14: {
      name: "Запечені свинні реберця",
      photo: "main/17.jpg",
      desc: "",
      storage:
        "Морква по-корейськи, Цибуля маринована, Ребра запечені, крем бальзамічний, салат листя",
      price: "400 UAH",
      weight: "800г",
      categoria: "Основні страви",
      id: 14,
    },
    // 15: {
    //   name: "Стейк Рібай Прайм",
    //   photo: "main/10.jpg",
    //   desc: "",
    //   storage: "Рібай, картопля, кукурудза, соус BBQ",
    //   price: "485 UAH",
    //   weight: "670г",
    //   categoria: "Основні страви",
    //   id: 15,
    // },
    16: {
      name: "Стейк свинний",
      photo: "main/24.jpg",
      desc: "",
      storage:
        "печериці, кабачок, перець болгарський,  свинний ошийок, цибуля кримська, соус BBQ",
      price: "225 UAH",
      weight: "445г",
      categoria: "Основні страви",
      id: 16,
    },
    // 17: {
    //   name: "Стейк курячий",
    //   photo: "main/25.jpg",
    //   desc: "",
    //   storage: "куряче філе, рис, горошок, вершки, в'ялені томати",
    //   price: "200 UAH",
    //   weight: "-",
    //   categoria: "Основні страви",
    //   id: 17,
    // },
    18: {
      name: "Ситий хлоп",
      photo: "for_companies/3.JPG",
      desc: "",
      storage:
        "Ребра запечені, Ковбаски курячі, Ковбаски свинні, курячі крила, Картопля, Цибулеві кільця, соус часниковий, салат листя, зелень, огірок маринований, Морква по-корейськи, Цибуля маринована, печериці, Соус Цезар, соус BBQ",
      price: "840 UAH",
      weight: "2000г",
      categoria: "Основні страви",
      id: 18,
    },
    19: {
      name: "Форель запечена",
      photo: "main/27.jpeg",
      desc: "",
      storage:
        "Апельсин, цибуля, ріпчаста вершки, ТріплСек, білі гриби, форель",
      price: "350 UAH",
      weight: "600г",
      categoria: "Основні страви",
      id: 19,
    },
    // 20: {
    //   name: "Філе форелі з рисом та овочами",
    //   photo: "main/28.jpeg",
    //   desc: "",
    //   storage: "Апельсин рис горошок масло форель",
    //   price: "370 UAH",
    //   weight: "500г",
    //   categoria: "Основні страви",
    //   id: 20,
    // },
  },
  Бургери: {
    1: {
      name: "Chiken burger",
      photo: "burgers/1.JPG",
      desc: "",
      storage:
        "Булка бріош, куряче філе, соєвий соус, огірок маринований, Помідор, сир чедер, картопляні діпи, соус сирний, Соус Цезар, айсберг, Соус барбекю, цибуля кримська",
      price: "210 UAH",
      weight: "450г",
      categoria: "Бургери",
      id: 1,
    },
    2: {
      name: "Truffle burger",
      photo: "burgers/2.JPG",
      desc: "",
      storage:
        "Булка бріош, соус сирний, фарш телячий, сир чедер, айсберг, картопляні діпи, Соус барбекю, соус трюфельний",
      price: "210 UAH",
      weight: "365г",
      categoria: "Бургери",
      id: 2,
    },
    // 3: {
    //   name: "Truffle burger з тигровими креветками",
    //   photo: "burgers/3.JPG",
    //   desc: "",
    //   storage:
    //     "Булка бріош, соус сирний, фарш телячий, сир чедер, айсберг, соус трюфельний, Тигрова креветка, картопляні діпи,Соус барбекю, Соус сицил. з маракуєю",
    //   price: "275 UAH",
    //   weight: "450г",
    //   categoria: "Бургери",
    //   id: 3,
    // },
    4: {
      name: "Double Cheese",
      photo: "burgers/5.jpg",
      desc: "",
      storage:
        "Булка Бріош, котлета теляча, соус шак, соус ранч, айсберг, морква по-корейськи, сир чедер, огірок маринований, листя салату, картопляні діпи, соус BBQ",
      price: "210 UAH",
      weight: "395г",
      categoria: "Бургери",
      id: 4,
    },
    5: {
      name: "Sweet Chilli",
      photo: "burgers/6.jpg",
      desc: "",
      storage:
        "Булка бріош, печена курка, лисят салату, цибуля конфі, соус світ чилі, соус ранч, соус BBQ, помідор, камамбер, картопляні діпи",
      price: "210 UAH",
      weight: "390г",
      categoria: "Бургери",
      id: 5,
    },
    6: {
      name: "Сирна ванна ",
      photo: "burgers/4.jpg",
      desc: "",
      storage: "",
      price: "80 UAH",
      weight: "100г",
      categoria: "Бургери",
      id: 6,
    },
  },
  Гарніри: {
    1: {
      name: "Картопляні діпи з соусом чедер та хрусткою цибулькою кріспі",
      photo: "garnirs/1.jpg",
      desc: "",
      storage: "картопляні діпи, Соус чедер, бекон, цибуля кріспі",
      price: "150 UAH",
      weight: "238г",
      categoria: "Гарніри",
      id: 1,
    },
    2: {
      name: "Картопляні діпи з часниковим соусом",
      photo: "garnirs/6.jpeg",
      desc: "",
      storage: "картопляні діпи, соус часниковий",
      price: "100 UAH",
      weight: "240г",
      categoria: "Гарніри",
      id: 2,
    },
    3: {
      name: "Картопляне пюре",
      photo: "garnirs/3.jpg",
      desc: "",
      storage: "картопляня, масло, молоко",
      price: "60 UAH",
      weight: "212г",
      categoria: "Гарніри",
      id: 3,
    },
    4: {
      name: "Овочі гриль",
      photo: "garnirs/4.jpg",
      desc: "",
      storage:
        "Помідор, печериці, баклажан, цибуля ріпчаста, перець болгарський, кабачок, соєвий соус, перець, крем бальзамічний, песто",
      price: "175 UAH",
      weight: "427г",
      categoria: "Гарніри",
      id: 4,
    },
    5: {
      name: "Картопля по-селянськи",
      photo: "garnirs/5.jpg",
      desc: "",
      storage: "Картопля, сіль, перець, прованські трави",
      price: "75 UAH",
      weight: "200г",
      categoria: "Гарніри",
      id: 5,
    },
    // 6: {
    //   name: "Рис з овочами",
    //   photo: "garnirs/7.jpeg",
    //   desc: "",
    //   storage: "Рис, Кукурудза, Морква, Броколі, Соус соєвий, Кунжут",
    //   price: "85 UAH",
    //   weight: "220г",
    //   categoria: "Гарніри",
    //   id: 6,
    // },
    7: {
      name: "Стручкова квасоля",
      photo: "garnirs/9.jpg",
      desc: "",
      storage: "Квасоля, Часник, Кунжут, Соус теріякі, Бальзамічний крем",
      price: "85 UAH",
      weight: "200г",
      categoria: "Гарніри",
      id: 7,
    },
  },
  // "Для компанії": {},
  Десерти: {
    1: {
      name: "Сирники",
      photo: "deserts/1.jpg",
      desc: "",
      storage: "",
      price: "140 UAH",
      weight: "400г",
      categoria: "Десерти",
      id: 1,
    },
    2: {
      name: "Тірамісу",
      photo: "deserts/17.jpg",
      desc: "",
      storage: "",
      price: "100 UAH",
      weight: "130г",
      categoria: "Десерти",
      id: 2,
    },
    3: {
      name: "Чізкейк",
      photo: "deserts/3.JPG",
      desc: "",
      storage: "",
      price: "130 UAH",
      weight: "100г",
      categoria: "Десерти",
      id: 3,
    },
    4: {
      name: "Панакота",
      photo: "deserts/4.jpg",
      desc: "",
      storage: "",
      price: "90 UAH",
      weight: "150г",
      categoria: "Десерти",
      id: 4,
    },
    5: {
      name: "Морозиво 'Балкон'",
      photo: "deserts/5.jpg",
      desc: "",
      storage: "",
      price: "95 UAH",
      weight: "120г",
      categoria: "Десерти",
      id: 5,
    },
    // 6: {
    //   name: "Шишка",
    //   photo: "deserts/10.jpg",
    //   desc: "Два муси з білого та чорного шоколаду, кокосове праліне. Зверху покрито ніжний шоколадним велюром",
    //   storage: "",
    //   price: "140 UAH",
    //   weight: "135г",
    //   categoria: "Десерти",
    //   id: 6,
    // },
    7: {
      name: "Наполеон",
      photo: "deserts/14.jpg",
      desc: "",
      storage: "",
      price: "125 UAH",
      weight: "120г",
      categoria: "Десерти",
      id: 7,
    },
    // 8: {
    //   name: "Спартак",
    //   photo: "deserts/8.jpg",
    //   desc: "",
    //   storage: "",
    //   price: "90 UAH",
    //   weight: "100г",
    //   categoria: "Десерти",
    //   id: 8,
    // },
    // 9: {
    //   name: "Палкий поцілунок",
    //   photo: "deserts/11.jpg",
    //   desc: "Полуничне мохіто - ванільний бісквіт , полуничне компоте , полунична намелака та ніжний мус мохіто",
    //   storage: "",
    //   price: "135 UAH",
    //   weight: "100г",
    //   categoria: "Десерти",
    //   id: 9,
    // },
    // 10: {
    //   name: "Снікерс",
    //   photo: "deserts/15.jpg",
    //   desc: "",
    //   storage: "",
    //   price: "135 UAH",
    //   weight: "120г",
    //   categoria: "Десерти",
    //   id: 10,
    // },
    11: {
      name: "Десерт `Вазонок`",
      photo: "deserts/16.jpeg",
      desc: "",
      storage:
        "Шоколад молочний, творог, масло, вершки, цедра лимона, Ванільний цукор, Печево шоколадне, Мята",
      price: "140 UAH",
      weight: "320г",
      categoria: "Десерти",
      id: 11,
    },
  },
  Додатки: {
    1: {
      name: "Чіабата",
      photo: "dodatki/1.webp",
      price: "6 UAH",
      weight: "30г",
      categoria: "Додатки",
      id: 1,
    },
    2: {
      name: "Бородинський",
      photo: "dodatki/2.webp",
      price: "4 UAH",
      weight: "30г",
      categoria: "Додатки",
      id: 2,
    },
    3: {
      name: "соус Часниковий",
      photo: "dodatki/3.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 3,
    },
    4: {
      name: "Кетчуп",
      photo: "dodatki/4.webp",
      price: "20 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 4,
    },
    5: {
      name: "соус Світ Чилі",
      photo: "dodatki/5.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 5,
    },
    6: {
      name: "Сметана",
      photo: "dodatki/6.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 6,
    },
    7: {
      name: "Соус Барбекю",
      photo: "dodatki/7.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 7,
    },
    8: {
      name: "Соус Ранч",
      photo: "dodatki/3.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 8,
    },
    9: {
      name: "соус Ікорний",
      photo: "dodatki/9.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 9,
    },
    10: {
      name: "Соус сирний",
      photo: "dodatki/10.webp",
      price: "40 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 10,
    },
    11: {
      name: "Соус Цезар",
      photo: "dodatki/11.webp",
      price: "30 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 11,
    },
    12: {
      name: "Мед",
      photo: "dodatki/12.webp",
      price: "10 UAH",
      weight: "40г",
      categoria: "Додатки",
      id: 12,
    },
    13: {
      name: "Сироп",
      photo: "dodatki/13.webp",
      price: "15 UAH",
      weight: "10г",
      categoria: "Додатки",
      id: 13,
    },
  },
  сети: {
    1: {
      name: "Сет Дракон",
      photo: "./q.png",
      desc: "",
      storage: "дракон дабл, тигровий дракон, Шу дракон",
      price: "629 UAH",
      weight: "871г",
      categoria: "сети",
      id: 1,
    },
    2: {
      name: "Гункан Сет",
      photo: "./q.png",
      desc: "",
      storage:
        "Гункан з лососем 4, Гункан з тунцем 4, Гункан з вугрем 4, гункан з креветко 4, гункан лосось спайсі 4",
      price: "1319 UAH",
      weight: "1136г",
      categoria: "сети",
      id: 2,
    },
    3: {
      name: "Дружній",
      photo: "./q.png",
      desc: "",
      storage:
        "філадельфія тобіко ебі, чорний дракон, макі вугор, макі креветка",
      price: "679 UAH",
      weight: "713г",
      categoria: "сети",
      id: 3,
    },
    4: {
      name: "Каліфорнія Сет",
      photo: "./q.png",
      desc: "",
      storage: "Каліфорнія з крабом, каліфорнія з лососем, каліфорнія з тунцем",
      price: "519 UAH",
      weight: "695г",
      categoria: "сети",
      id: 4,
    },
    5: {
      name: "Макі сет",
      photo: "./q.png",
      desc: "",
      storage: "макі лосось, макі тунець, макі огірок, макі авокадо",
      price: "189 UAH",
      weight: "485г",
      categoria: "сети",
      id: 5,
    },
    6: {
      name: "Філадельфія сет",
      photo: "./q.png",
      desc: "",
      storage:
        "філадельфія гриль, філадельфія унагі, макі лосось, Нігірі лосось 3",
      price: "709 UAH",
      weight: "821г",
      categoria: "сети",
      id: 6,
    },
  },
  філадельфія: {
    1: {
      name: "Філадельфія Чука",
      photo: "sushi/fil_1.jpg",
      desc: "",
      storage:
        "Норі, рис , Кремета сир ,авокадо, лосось ,хіяші салат, горіховий соус ,кунжут",
      price: "289 UAH",
      weight: "308г",
      categoria: "філадельфія",
      id: 1,
    },
    2: {
      name: "Філадельфія Авокадо",
      photo: "sushi/fil_2.jpg",
      desc: "",
      storage: "рис, норі, Кремета сир, авокадо, Ікра масаго, лосось",
      price: "289 UAH",
      weight: "255г",
      categoria: "філадельфія",
      id: 2,
    },
    3: {
      name: "Філадельфія Гриль",
      photo: "sushi/fil_3.jpg",
      desc: "",
      storage:
        "Норі, рис,  Кремета сир,	огірок, авокадо ,лосось	 горіховий соус	кунжут ",
      price: "289 UAH",
      weight: "273г",
      categoria: "філадельфія",
      id: 3,
    },
    4: {
      name: "Філадельфія з лососем і чеддером",
      photo: "sushi/fil_4.jpg",
      desc: "",
      storage:
        "Рис, норі,сир кремета, авокадо, ікра масаго,лосось, сир чедер, ікра ",
      price: "309 UAH",
      weight: "255г",
      categoria: "філадельфія",
      id: 4,
    },
    5: {
      name: "Філадельфія з Манго",
      photo: "sushi/fil_5.jpg",
      desc: "",
      storage: "Норі, рис, сир кремета,манго, лосось",
      price: "189 UAH",
      weight: "200г",
      categoria: "філадельфія",
      id: 5,
    },
    6: {
      name: "Філадельфія Капа з вугрем",
      photo: "sushi/fil_6.jpg",
      desc: "",
      storage: "Норі,рис,сир кремета,огірок, вугор,лосось",
      price: "319 UAH",
      weight: "275г",
      categoria: "філадельфія",
      id: 6,
    },
    7: {
      name: "Філадельфія Огірок",
      photo: "sushi/fil_7.jpg",
      desc: "",
      storage: "Сир, норі, сир кремета. Огірок , ікра масаго,лосось",
      price: "249 UAH",
      weight: "250г",
      categoria: "філадельфія",
      id: 7,
    },
    8: {
      name: "Філадельфія Сяке",
      photo: "sushi/fil_8.jpg",
      desc: "",
      storage: "Норі, рис, сир кремета,лосось",
      price: "249 UAH",
      weight: "240г",
      categoria: "філадельфія",
      id: 8,
    },
    9: {
      name: "Філадельфія Сяке в омлеті",
      photo: "sushi/fil_9.jpg",
      desc: "",
      storage:
        "Норі, рис, сир кремета,огірок, лосось, омлет тамаго, соус унагі",
      price: "279 UAH",
      weight: "255г",
      categoria: "філадельфія",
      id: 9,
    },
    10: {
      name: "Філадельфія Тобіко",
      photo: "sushi/fil_10.jpg",
      desc: "",
      storage: "Норі, рис, сир кремета,ікра масаго,лосось",
      price: "299 UAH",
      weight: "245г",
      categoria: "філадельфія",
      id: 10,
    },
    11: {
      name: "Філадельфія Тобіко Ебі",
      photo: "sushi/fil_11.jpg",
      desc: "",
      storage: "Норі, рис, сир кремета, огірок, креветка, ікра масаго",
      price: "279 UAH",
      weight: "250г",
      categoria: "філадельфія",
      id: 11,
    },
    12: {
      name: "Філадельфія Унагі",
      photo: "sushi/fil_12.jpg",
      desc: "",
      storage:
        "Норі, рис, сир кремета, огірок, авокадо, вугор, соус унагі, кунжут",
      price: "249 UAH",
      weight: "278г",
      categoria: "філадельфія",
      id: 12,
    },
  },
  дракони: {
    1: {
      name: "Дракон Дабл",
      photo: "sushi/dr_1.jpg",
      desc: "",
      storage:
        "Норі,рис,сир кремета, огірок, ікра масаго, сніжний краб,лосось, авокадо,соус унагі,кунжут",
      price: "289 UAH",
      weight: "288г",
      categoria: "дракони",
      id: 1,
    },
    2: {
      name: "Тигровий Дракон",
      photo: "sushi/dr_2.jpg",
      desc: "",
      storage: "Норі,рис, сир кремета,огірок, ікра масаго, креветка, кунжут",
      price: "299 UAH",
      weight: "295г",
      categoria: "дракони",
      id: 2,
    },
    3: {
      name: "Чорний Дракон",
      photo: "sushi/dr_3.jpg",
      desc: "",
      storage:
        "Норі, рис, сир кремета,огірок, ікра масаго, омлет тамаго, вугор, соус унагі,кунжут",
      price: "279 UAH",
      weight: "273г",
      categoria: "дракони",
      id: 3,
    },
    4: {
      name: "Шу Дракон",
      photo: "sushi/dr_4.jpg",
      desc: "",
      storage:
        "Норі, рис, сир кремета, огірок, ікра масаго,лосоь, тунець, креветка, вугор, соус унагі,кунжут",
      price: "199 UAH",
      weight: "233г",
      categoria: "дракони",
      id: 4,
    },
  },
  преміум: {
    1: {
      name: "Енігма",
      photo: "sushi/pr_1.png",
      desc: "",
      storage:
        "Рис, норі, сир кремета,майонез японський,тунець,омлет тамаго, авокадо,соус унагі",
      price: "279 UAH",
      weight: "275г",
      categoria: "преміум",
      id: 1,
    },
    2: {
      name: "Канада",
      photo: "sushi/pr_2.jpg",
      desc: "",
      storage:
        "Рис,чорнило каракатиці, норі,сир кремета,лосось, авокадо, вугор, соус унагі",
      price: "299 UAH",
      weight: "278г",
      categoria: "преміум",
      id: 2,
    },
    3: {
      name: "Маямі",
      photo: "sushi/pr_3.jpg",
      desc: "",
      storage:
        "Рис, норі, сир кремета,ікра масаго, огірок, авокадо, тунець на грилі, соус унагі",
      price: "279 UAH",
      weight: "280г",
      categoria: "преміум",
      id: 3,
    },
    4: {
      name: "Унагі Преміум",
      photo: "sushi/pr_4.jpg",
      desc: "",
      storage: "Норі,рис, сир кремета,авокадо, вугор, лосось, ікра масаго",
      price: "309 UAH",
      weight: "275г",
      categoria: "преміум",
      id: 4,
    },
    5: {
      name: "Філадельфія Преміум",
      photo: "sushi/pr_5.jpg",
      desc: "",
      storage: "Норі, рис, сир кремета, сніжний краб, огірок, лосось",
      price: "349 UAH",
      weight: "375г",
      categoria: "преміум",
      id: 5,
    },
    6: {
      name: "Хукаге",
      photo: "sushi/pr_6.jpg",
      desc: "",
      storage:
        "Норі, рис лосось, майонез японський, ікра масаго, сніжний краб,креветка",
      price: "289 UAH",
      weight: "290г",
      categoria: "преміум",
      id: 6,
    },
    7: {
      name: "Хумаварі",
      photo: "sushi/pr_7.jpg",
      desc: "",
      storage:
        "Рис, чорнило каракатиці, норі, майонез японський,лосось, креветка,омлет тамаго, сир чедер, пармезан",
      price: "319 UAH",
      weight: "238г",
      categoria: "преміум",
      id: 7,
    },
    8: {
      name: "Яматомо",
      photo: "sushi/pr_8.jpg",
      desc: "",
      storage:
        "Норі, рис, сир кремета, ікра масаго, сніжний краб, креветка, авокадо, лосось",
      price: "389 UAH",
      weight: "355г",
      categoria: "преміум",
      id: 8,
    },
  },
  КАЛІФОРНІЯ: {
    1: {
      name: "Каліфорнія з Вугрем",
      photo: "sushi/kl_1.jpg",
      desc: "",
      storage:
        "Норі, рис, майонез японський, огірок, авокадо, вугор,укра масаго",
      price: "219 UAH",
      weight: "225г",
      categoria: "КАЛІФОРНІЯ",
      id: 1,
    },
    2: {
      name: "Каліфорнія з Тунцем",
      photo: "sushi/kl_2.jpg",
      desc: "",
      storage:
        "Норі, рис, майонез японський, огірок, авокадо, тунець, ікра масаго",
      price: "209 UAH",
      weight: "225г",
      categoria: "КАЛІФОРНІЯ",
      id: 2,
    },
    3: {
      name: "Каліфорнія Краб",
      photo: "sushi/kl_3.jpg",
      desc: "",
      storage:
        "Рис, норі, майонез японський, огірок, авокадо, сніжний краб, ікра масаго",
      price: "199 UAH",
      weight: "245г",
      categoria: "КАЛІФОРНІЯ",
      id: 3,
    },
    4: {
      name: "Каліфорнія Креветка",
      photo: "sushi/kl_4.jpg",
      desc: "",
      storage:
        "Норі, рис, майонез японський, огірок, авокадо, креветка, ікра масаго",
      price: "229 UAH",
      weight: "235г",
      categoria: "КАЛІФОРНІЯ",
      id: 4,
    },
    5: {
      name: "Каліфорнія Лосось",
      photo: "sushi/kl_5.png",
      desc: "",
      storage:
        "Норі, рис,майонез японський, огірок, авокадо, лосось, ікра масаго",
      price: "219 UAH",
      weight: "225г",
      categoria: "КАЛІФОРНІЯ",
      id: 5,
    },
  },
  роли: {
    1: {
      name: "4 сири і креветка",
      photo: "sushi/rl_1.jpg",
      desc: "",
      storage:
        "Рис, норі, сир кремета, моцарела, креветка, сир чедер, соус унагі, пармезан",
      price: "270 UAH",
      weight: "255г",
      categoria: "роли",
      id: 1,
    },
    2: {
      name: "Боні",
      photo: "sushi/rl_2.jpg",
      desc: "",
      storage:
        "Рис, норі, соус спайсі, лосось, огірок, омлет тамаго, стружка тунця",
      price: "240 UAH",
      weight: "230г",
      categoria: "роли",
      id: 2,
    },
    3: {
      name: "Мацумі",
      photo: "sushi/rl_3.jpg",
      desc: "",
      storage:
        "Рис, норі, майонез японський, вугор, ікра масаго, зелена цибуля, лосось",
      price: "259 UAH",
      weight: "223г",
      categoria: "роли",
      id: 3,
    },
    4: {
      name: "Нагасакі",
      photo: "sushi/rl_4.jpg",
      desc: "",
      storage:
        "Рис, норі, соус спайсі, зелена цибуля, авокадо, омлет тамаго, сніжний краб, лосось",
      price: "239 UAH",
      weight: "278г",
      categoria: "роли",
      id: 4,
    },
    5: {
      name: "Сай",
      photo: "sushi/rl_5.jpg",
      desc: "",
      storage:
        "Рис, норі, сир кремета, соус шрірачі, , вугор, манго, ікра масаго, зелена цибуля, авокадо, соус унагі",
      price: "239 UAH",
      weight: "283г",
      categoria: "роли",
      id: 5,
    },
    6: {
      name: "Хіяші",
      photo: "sushi/rl_6.jpg",
      desc: "",
      storage:
        "Норі, рис, сир кремета, сніжний краб,креветка, ікра масаго, чука, горіховий соус",
      price: "269 UAH",
      weight: "290г",
      categoria: "роли",
      id: 6,
    },
  },
  МАКІ: {
    1: {
      name: "Макі авокадо",
      photo: "sushi/mk_1.jpg",
      desc: "",
      storage: "Норі, рис, авокадо, соус унагі",
      price: "59 UAH",
      weight: "125г",
      categoria: "МАКІ",
      id: 1,
    },
    2: {
      name: "Макі Вугор",
      photo: "sushi/mk_2.jpg",
      desc: "",
      storage: "Норі, рис, вугор, соус унагі",
      price: "129 UAH",
      weight: "125г",
      categoria: "МАКІ",
      id: 2,
    },
    3: {
      name: "Макі Креветка",
      photo: "sushi/mk_3.jpg",
      desc: "",
      storage: "Норі, рис, соус спайсі, креветка",
      price: "119 UAH",
      weight: "135г",
      categoria: "МАКІ",
      id: 3,
    },
    4: {
      name: "Макі лосось",
      photo: "sushi/mk_4.png",
      desc: "",
      storage: "Норі, рис, лосось",
      price: "109 UAH",
      weight: "120г",
      categoria: "МАКІ",
      id: 4,
    },
    5: {
      name: "Макі огірок",
      photo: "sushi/mk_5.jpg",
      desc: "",
      storage: "Норі, рис, огірок",
      price: "49 UAH",
      weight: "120г",
      categoria: "МАКІ",
      id: 5,
    },
    6: {
      name: "Макі тунець",
      photo: "sushi/mk_6.png",
      desc: "",
      storage: "Норі, рис, тунець",
      price: "89 UAH",
      weight: "120г",
      categoria: "МАКІ",
      id: 6,
    },
    7: {
      name: "Макі чука",
      photo: "sushi/mk_7.jpg",
      desc: "",
      storage: "Норі, рис, чука,горіховий соус",
      price: "69 UAH",
      weight: "125г",
      categoria: "МАКІ",
      id: 7,
    },
  },
  ГУНКАН: {
    1: {
      name: "Гункан вугор",
      photo: "sushi/gn_1.jpg",
      desc: "",
      storage: "Рис, норі, вугор,японський майонез, ікра",
      price: "90 UAH",
      weight: "58г",
      categoria: "ГУНКАН",
      id: 1,
    },
    2: {
      name: "Гункан Креветка",
      photo: "sushi/gn_2.png",
      desc: "",
      storage: "Рис, норі, креветка, японський майонез, ікра масаго",
      price: "79 UAH",
      weight: "58г",
      categoria: "ГУНКАН",
      id: 2,
    },
    3: {
      name: "Гункан Лосось",
      photo: "sushi/gn_3.jpg",
      desc: "",
      storage: "Рис, норі, лосось, японський майонез, ікра масаго",
      price: "79 UAH",
      weight: "58г",
      categoria: "ГУНКАН",
      id: 3,
    },
    4: {
      name: "Гункан лосось спайсі",
      photo: "sushi/gn_4.png",
      desc: "",
      storage: "Рис, норі, лосось, соус спайсі, зелена цибуля",
      price: "70 UAH",
      weight: "58г",
      categoria: "ГУНКАН",
      id: 4,
    },
    5: {
      name: "Гункан тунець",
      photo: "sushi/gn_5.jpg",
      desc: "",
      storage: "Рис, норі, тунець, японський майонез, ікра масаго",
      price: "79 UAH",
      weight: "58г",
      categoria: "ГУНКАН",
      id: 5,
    },
    6: {
      name: "Гункан тунець спайсі",
      photo: "sushi/gn_6.jpg",
      desc: "",
      storage: "Рис, норі, тунець, соус спайсі, зелена цибуля",
      price: "79 UAH",
      weight: "58г",
      categoria: "ГУНКАН",
      id: 6,
    },
  },
  НІГІРІ: {
    1: {
      name: "Нігірі Вугор",
      photo: "sushi/ng_1.jpg",
      desc: "",
      storage: "Рис, васабі, вугор, норі, соус унагі, кунжут",
      price: "59 UAH",
      weight: "50г",
      categoria: "НІГІРІ",
      id: 1,
    },
    2: {
      name: "Нігірі з лососем",
      photo: "sushi/ng_2.jpg",
      desc: "",
      storage: "Рис, васабі, лосось",
      price: "69 UAH",
      weight: "50г",
      categoria: "НІГІРІ",
      id: 2,
    },
    3: {
      name: "Нігірі з тунцем",
      photo: "sushi/ng_3.jpg",
      desc: "",
      storage: "Рис, васабі, тунець",
      price: "59 UAH",
      weight: "50г",
      categoria: "НІГІРІ",
      id: 3,
    },
    4: {
      name: "Нігірі Креветка",
      photo: "sushi/ng_4.jpg",
      desc: "",
      storage: "Рис, васабі, креветка",
      price: "69 UAH",
      weight: "50г",
      categoria: "НІГІРІ",
      id: 4,
    },
  },
  Кава: {
    1: {
      name: "еспрессо",
      photo: "coffee/19.jpeg",
      price: "35 UAH",
      weight: "30г",
      categoria: "Кава",
      id: 1,
    },
    2: {
      name: "американо",
      photo: "coffee/2.jpeg",
      price: "35 UAH",
      weight: "100г",
      categoria: "Кава",
      id: 2,
    },
    3: {
      name: "допіо",
      photo: "coffee/3.jpg",
      price: "70 UAH",
      weight: "60г",
      categoria: "Кава",
      id: 3,
    },
    4: {
      name: "капучино",
      photo: "coffee/1.jpg",
      price: "45 UAH",
      weight: "230г",
      categoria: "Кава",
      id: 4,
    },
    5: {
      name: "капучино на рослинному",
      photo: "coffee/5.jpeg",
      price: "50 UAH",
      weight: "230г",
      categoria: "Кава",
      id: 5,
    },
    6: {
      name: "лате",
      photo: "coffee/6.jpg",
      price: "50 UAH",
      weight: "270г",
      categoria: "Кава",
      id: 6,
    },
    7: {
      name: "Бамблбі",
      photo: "coffee/20.jpeg",
      price: "90 UAH",
      weight: "180г",
      storage: "сироп карамель, сік апельсин, еспрессо",
      categoria: "Кава",
      id: 7,
    },
    8: {
      name: "лате pink / лате blue",
      photo: "coffee/8.jpg",
      price: "75 UAH",
      weight: "270г",
      categoria: "Кава",
      id: 8,
    },
    9: {
      name: "лате на рослинному",
      photo: "coffee/9.jpg",
      price: "49 UAH",
      weight: "270г",
      categoria: "Кава",
      id: 9,
    },
    10: {
      name: "молоко до кави",
      photo: "coffee/7.jpeg",
      price: "7 UAH",
      weight: "50г",
      categoria: "Кава",
      id: 10,
    },
    11: {
      name: "молоко до кави рослинне",
      photo: "coffee/7.jpeg",
      price: "15 UAH",
      weight: "50г",
      categoria: "Кава",
      id: 11,
    },
    12: {
      name: "аффогато",
      photo: "coffee/10.jpeg",
      price: "70 UAH",
      weight: "80г",
      categoria: "Кава",
      id: 12,
    },
    13: {
      name: "рістрето",
      photo: "coffee/11.jpeg",
      price: "35 UAH",
      weight: "20г",
      categoria: "Кава",
      id: 13,
    },
    14: {
      name: "раф кава",
      photo: "coffee/12.jpeg",
      price: "80 UAH",
      weight: "200г",
      categoria: "Кава",
      id: 14,
    },
    15: {
      name: "снікерс лате",
      photo: "coffee/15.jpg",
      price: "75 UAH",
      categoria: "Кава",
      weight: "400г",
      id: 15,
    },
    16: {
      name: "флет-вайт",
      photo: "coffee/13.jpeg",
      price: "60 UAH",
      categoria: "Кава",
      weight: "230г",
      id: 16,
    },
    17: {
      name: "кава 'по-естонськи'",
      photo: "coffee/17.jpg",
      price: "80 UAH",
      categoria: "Кава",
      weight: "230г",
      id: 17,
    },
    18: {
      name: "кава 'по-ірландськи'",
      photo: "coffee/18.jpg",
      price: "110 UAH",
      categoria: "Кава",
      weight: "230г",
      id: 18,
    },
    19: {
      name: "какао",
      photo: "coffee/14.jpeg",
      price: "45 UAH",
      categoria: "Кава",
      weight: "230г",
      id: 19,
    },
  },
  "Заварні чаї": {
    1: {
      name: "Чорний чай",
      photo: "tia/1.1.jpeg",
      price: "60 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 1,
    },
    2: {
      name: "Чорний з бергамотом",
      photo: "tia/1.1.jpeg",
      price: "60 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 2,
    },
    3: {
      name: "Зелений чай",
      photo: "tia/1.3.jpeg",
      price: "60 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 3,
    },
    4: {
      name: "Зелений з жасмином",
      photo: "tia/1.4.jpeg",
      price: "60 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 4,
    },
    5: {
      name: "Фруктовий чай",
      photo: "tia/1.5.jpeg",
      price: "60 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 5,
    },
    6: {
      name: "Трав'яний чай",
      photo: "tia/1.6.jpeg",
      price: "60 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 6,
    },
    7: {
      name: "Анчан",
      photo: "tia/1.7.webp",
      price: "90 UAH",
      weight: "300г",
      categoria: "Заварні чаї",
      id: 7,
    },
  },
  "Порційні чаї": {
    1: {
      name: "Облипиха - розмарин",
      photo: "tia/2.jpeg",
      price: "60 UAH",
      weight: "200г",
      categoria: "Порційні чаї",
      id: 1,
    },
    2: {
      name: "Журавлина - апельсин",
      photo: "tia/1.jpg",
      price: "60 UAH",
      weight: "200г",
      categoria: "Порційні чаї",
      id: 2,
    },
  },
  "Чаї власного виробництва": {
    1: {
      name: "Обліпиха - імбир",
      photo: "./q.png",
      price: "80 UAH",
      weight: "400г",
      categoria: "Чаї власного виробництва",
      id: 1,
    },
    2: {
      name: "Яблуко - кориця",
      photo: "./q.png",
      price: "80 UAH",
      weight: "400г",
      categoria: "Чаї власного виробництва",
      id: 2,
    },
    3: {
      name: "Мараканський манго - лайм",
      photo: "./q.png",
      price: "80 UAH",
      weight: "400г",
      categoria: "Чаї власного виробництва",
      id: 3,
    },
    4: {
      name: "Малина - роза",
      photo: "./q.png",
      price: "80 UAH",
      weight: "400г",
      categoria: "Чаї власного виробництва",
      id: 4,
    },
  },
  лимонади: {
    1: {
      name: "Лимонад Ягідний BOOM",
      photo: "not-alcohol/1.1.jpg",
      price: "70 UAH",
      weight: "250г",
      categoria: "лимонади",
      id: 1,
    },
    2: {
      name: "Лимонад класичний",
      photo: "not-alcohol/1.2.jpg",
      price: "70 UAH",
      weight: "250г",
      categoria: "лимонади",
      id: 2,
    },
    3: {
      name: "Лимонад Екзотичний рай",
      photo: "not-alcohol/1.3.jpg",
      price: "70 UAH",
      weight: "250г",
      categoria: "лимонади",
      id: 3,
    },
    4: {
      name: "Лимонад свіжий бриз",
      photo: "not-alcohol/1.4.jpg",
      price: "70 UAH",
      weight: "250г",
      categoria: "лимонади",
      id: 4,
    },
  },
  "Домашні Закрутки": {
    1: {
      name: "компот Вишневий",
      photo: "home/1.jpg",
      price: "150 UAH",
      weight: "1 л",
      categoria: "Домашні Закрутки",
      id: 1,
    },
    2: {
      name: "компот Малиновий",
      photo: "home/2.jpg",
      price: "150 UAH",
      weight: "1 л",
      categoria: "Домашні Закрутки",
      id: 2,
    },
    3: {
      name: "Узвар",
      photo: "home/3.jpg",
      price: "150 UAH",
      weight: "1 л",
      categoria: "Домашні Закрутки",
      id: 3,
    },
  },
  фреші: {
    1: {
      name: "Апельсиновий фреш",
      photo: "./q.png",
      price: "80 UAH",
      weight: "200г",
      categoria: "фреші",
      id: 1,
    },
    2: {
      name: "Грейпрутовий фреш",
      photo: "./q.png",
      price: "85 UAH",
      weight: "200г",
      categoria: "фреші",
      id: 2,
    },
  },
  "молочні коктейлі": {
    1: {
      name: "Молочний коктейль 'банановий'",
      photo: "not-alcohol/3.1.jpg",
      price: "99 UAH",
      weight: "350г",
      categoria: "молочні коктейлі",
      id: 1,
    },
    2: {
      name: "Молочний коктейль 'класичний'",
      photo: "not-alcohol/3.2.jpg",
      price: "99 UAH",
      weight: "300г",
      categoria: "молочні коктейлі",
      id: 2,
    },
  },
  "б/а напої": {
    1: {
      name: "Девайтіс 0.5",
      photo: "not-alcohol/4.1.jpeg",
      desc: "слабогазована / негазована",
      price: "60 UAH",
      weight: "500г",
      categoria: "лимонади",
      id: 1,
    },
    2: {
      name: "Пепсі 0.5",
      photo: "not-alcohol/4.2.jpeg",
      price: "65 UAH",
      weight: "500г",
      categoria: "лимонади",
      id: 2,
    },
    3: {
      name: "Сік в асортиненті",
      photo: "not-alcohol/4.3.png",
      desc: "яблуко, вишня, мультифрукт, ананас, апельсин, груша",
      price: "44 UAH",
      weight: "250г",
      categoria: "лимонади",
      id: 3,
    },
  },
  "б/а коктейлі": {
    1: {
      name: "Мохіто",
      photo: "not-alcohol/5.1.jpg",
      price: "90 UAH",
      weight: "300г",
      categoria: "б/а коктейлі",
      id: 1,
    },
    2: {
      name: "Апероль",
      photo: "coctails/4.jpeg",
      price: "90 UAH",
      weight: "300г",
      categoria: "б/а коктейлі",
      id: 2,
    },
  },
  "зігріваючі напої": {
    1: {
      name: "Глінтвейн",
      photo: "./q.png",
      price: "90 UAH",
      weight: "230г",
      categoria: "зігріваючі напої",
      id: 1,
    },
  },
  Ром: {
    1: {
      name: "Captan Morgan (GOLD)",
      photo: "alcohol/rom/1.jpeg",
      price: "90 UAH",
      weight: "50г",
      categoria: "Ром",
      id: 1,
    },
    2: {
      name: "Баккарді карта бланка",
      photo: "alcohol/rom/3.jpg",
      price: "85 UAH",
      weight: "50г",
      categoria: "Ром",
      id: 2,
    },
    3: {
      name: "Бакарді карта негра",
      photo: "alcohol/rom/2.jpg",
      price: "85 UAH",
      weight: "50г",
      categoria: "Ром",
      id: 3,
    },
  },
  Текіла: {
    1: {
      name: "ESPOLON",
      photo: "alcohol/tekila/1.jpeg",
      price: "120 UAH",
      weight: "50г",
      categoria: "Текіла",
      id: 1,
    },
    2: {
      name: "OLMECA BLANCO",
      photo: "alcohol/tekila/2.jpg",
      price: "99 UAH",
      weight: "50г",
      categoria: "Текіла",
      id: 2,
    },
  },
  Горілка: {
    1: {
      name: "FINLANDIA",
      photo: "alcohol/vodka/1.jpeg",
      desc: "Класична, Чорниця",
      price: "65 UAH",
      weight: "50г",
      categoria: "Горілка",
      id: 1,
    },
    2: {
      name: "GREEN DAY",
      photo: "alcohol/vodka/2.jpg",
      price: "30 UAH",
      weight: "50г",
      categoria: "Горілка",
      id: 2,
    },
    3: {
      name: "NEMIROFF",
      photo: "alcohol/vodka/3.jpeg",
      price: "35 UAH",
      weight: "50г",
      categoria: "Горілка",
      id: 3,
    },
    4: {
      name: "ABSOLUT Grapefruit",
      photo: "alcohol/vodka/4.jpeg",
      price: "60 UAH",
      weight: "50г",
      categoria: "Горілка",
      id: 4,
    },
  },
  Віскі: {
    1: {
      name: "Jack Daniels",
      photo: "alcohol/viskey/1.jpeg",
      price: "115 UAH",
      weight: "50г",
      categoria: "Віскі",
      id: 1,
    },
    2: {
      name: "Jack Daniels Honey",
      photo: "alcohol/viskey/2.jpeg",
      price: "115 UAH",
      weight: "50г",
      categoria: "Віскі",
      id: 2,
    },
    3: {
      name: "Jack Daniels Apple",
      photo: "alcohol/viskey/3.jpg",
      price: "115 UAH",
      weight: "50г",
      categoria: "Віскі",
      id: 3,
    },
    4: {
      name: "JAMESON",
      photo: "alcohol/viskey/4.jpg",
      price: "120 UAH",
      weight: "50г",
      categoria: "Віскі",
      id: 4,
    },
    5: {
      name: "CHIVAS",
      photo: "alcohol/viskey/5.jpeg",
      price: "150 UAH",
      weight: "50г",
      categoria: "Віскі",
      id: 5,
    },
    6: {
      name: "bourbon Four Roses",
      photo: "alcohol/viskey/6.png",
      price: "95 UAH",
      weight: "50г",
      categoria: "Віскі",
      id: 6,
    },
  },
  "Лікери та Настоянки": {
    1: {
      name: "BAILEYS",
      photo: "alcohol/liker/1.jpeg",
      price: "95 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 1,
    },
    2: {
      name: "VANA TALLIN",
      photo: "alcohol/liker/2.jpeg",
      price: "70 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 2,
    },
    3: {
      name: "БЕХЕРОВКА",
      photo: "alcohol/liker/3.jpeg",
      price: "65 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 3,
    },
    4: {
      name: "JAGERMEISTER",
      photo: "alcohol/liker/4.jpg",
      price: "90 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 4,
    },
    5: {
      name: "МАРТІНІ БЬЯНКО",
      photo: "alcohol/liker/5.jpeg",
      price: "45 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 5,
    },
    6: {
      name: "МАРТІНІ РОССО",
      photo: "alcohol/liker/6.jpeg",
      price: "55 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 6,
    },
    7: {
      name: "Абсент",
      photo: "alcohol/liker/7.jpeg",
      price: "150 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 7,
    },
    8: {
      name: "Самбука",
      photo: "alcohol/liker/8.jpeg",
      price: "60 UAH",
      weight: "50г",
      categoria: "Лікери та Настоянки",
      id: 8,
    },
  },
  Пиво: {
    1: {
      name: "grimbergen blanche",
      photo: "alcohol/bear/5.jpeg",
      price: "60/85 UAH",
      weight: "300г, 500г",
      categoria: "Пиво",
      id: 1,
    },
    2: {
      name: "kronenbourg blanc",
      photo: "alcohol/bear/6.jpeg",
      price: "40/55 UAH",
      weight: "300г, 500г",
      categoria: "Пиво",
      id: 2,
    },
    3: {
      name: "carlsberg",
      photo: "alcohol/bear/7.png",
      price: "60/85 UAH",
      weight: "300г, 500г",
      categoria: "Пиво",
      id: 3,
    },
    4: {
      name: "VOLFAS ENGELMAN IPA",
      photo: "alcohol/bear/4.jpeg",
      price: "80 UAH",
      weight: "50г",
      categoria: "Пиво",
      id: 4,
    },
    5: {
      name: "БАВАРІЯ Б/А",
      photo: "alcohol/bear/3.jpeg",
      price: "75 UAH",
      weight: "500г",
      categoria: "Пиво",
      id: 5,
    },
  },
  "Білі Вина": {
    1: {
      name: "Chatelain Clemont",
      photo: "alcohol/white_vine/7.jpeg",
      desc: "напів солодке. Виготовлене у Франції",
      storage: "",
      price: "65 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 1,
    },
    2: {
      name: "BARON D`ARIGNAC",
      photo: "alcohol/white_vine/1.jpg",
      desc: "напів солодке. Виготовлене у Франції",
      storage: "Столове класичне вино",
      price: "65 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 2,
    },
    3: {
      name: "Каппо Москато J Garsia Carrion",
      photo: "alcohol/white_vine/2.jpg",
      desc: "сухе, виготовленно в Іспанії",
      storage:
        "Це чудовий напій, який зачаровує яскравими лимонними відтінками. Така зовнішність навіває неймовірне почуття легкості та свіжості",
      price: "60 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 3,
    },
    4: {
      name: "Колоніст Рислінг",
      photo: "alcohol/white_vine/3.jpg",
      desc: "напівсухе, виготовленно в Україні",
      storage:
        "Виготовлено з винограду сорту Рислінг рейнський власних плантацій ТМ «Колоніст». Смак: м'який, гармонійний, з тонкими мінеральними тонами, що поступово переходить у тропічні фрукти. Аромат: свіжий, яскравий, з домінуючими тонами манго та білого персика, елегантними гудронними нотами і відтінками квітів.",
      price: "90 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 4,
    },
    5: {
      name: "Колоніст Сухолиманське",
      photo: "alcohol/white_vine/4.jpg",
      desc: "сухе вино, виготовленно в Україні",
      storage:
        "Прозоро-золотистий. Легке, гармонійне вино демонструє аромати степових трав, ревеню та дині. Освіжаючий смак з відтінками мускату і бузку чудово втамує спрагу в найспекотніший день.",
      price: "90 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 5,
    },
    6: {
      name: "Мальборо Сан Совінйон Блан",
      photo: "alcohol/white_vine/5.jpg",
      desc: "сухе вино, виготовленно в Новій Зеландії",
      storage:
        "свіжий хрусткий смак з тонами тропічних фруктів (маракуйи) і кісточкових плодів, а також нотками агрусу і свіжих трав.",
      price: "120 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 6,
    },
    7: {
      name: "Піно Гріджіо Венето",
      photo: "alcohol/white_vine/6.jpg",
      desc: "сухе вино, виготовлене в Італії",
      storage:
        "це універсальне вино, яке сподобається кожному. Воно дуже легке, приємне, свіже, зі збалансованою кислинко із нотою яблука і агруса.",
      price: "85 UAH",
      weight: "100г",
      categoria: "Білі Вина",
      id: 7,
    },
  },
  "Червоні Вина": {
    1: {
      name: "Belle Melanie",
      photo: "alcohol/red_vine/6.webp",
      desc: "напів солодке. Виготовлене у Франції",
      storage: "",
      price: "65 UAH",
      weight: "100г",
      categoria: "Червоні Вина",
      id: 1,
    },
    2: {
      name: "BARON D`ARIGNAC",
      photo: "alcohol/red_vine/1.jpg",
      desc: "напів солодке. Виготовлене у Франції",
      storage:
        "Вино Baron d'Arignac Rouge має глибокий червоний колір, який схожий на рубін і має легкий аромат червоних ягід. Напій чудово поєднується з червоним м'ясом, сирами та пастою.",
      price: "65 UAH",
      weight: "100г",
      categoria: "Червоні Вина",
      id: 2,
    },
    3: {
      name: "Каппо Шираз J Garcia Carrion",
      photo: "alcohol/red_vine/2.jpg",
      desc: "сухе, виготовленно в Іспанії",
      storage:
        "Це вельми насичене вино, виготовлене з найкращих лоз Шираз, що вирощується під яскравим сонцем на сприятливих ґрунтах. Дозріваючи в таких умовах, ягоди набувають насичений смак та аромат.",
      price: "60 UAH",
      weight: "100г",
      categoria: "Червоні Вина",
      id: 3,
    },
    4: {
      name: "Одеське чорне",
      photo: "alcohol/red_vine/3.jpg",
      desc: "сухе, виготовленно в Україні",
      storage:
        "виготовлено за традиційною виноробною технологією виготовлення сухих вин. Це вино витримано протягом 6-ти місяців у французьких барріках зі столітнього дуба, що надає напою розвинений смак з тонами шовковиці, чорносливу та димними нотами й яскравою танінністю.",
      price: "90 UAH",
      weight: "100г",
      categoria: "Червоні Вина",
      id: 4,
    },
    5: {
      name: "Руффіно К'янті",
      photo: "alcohol/red_vine/4.jpg",
      desc: "сухе вино, виготовленно в Італії",
      storage:
        "Вино червоне з квітковими нотками фіалки, фруктовим ароматам сливи, черешні і злегка пряним присмаком.",
      price: "120 UAH",
      weight: "100г",
      categoria: "Червоні Вина",
      id: 5,
    },
    6: {
      name: "Мальборо Сан Совінйон Блан",
      photo: "alcohol/red_vine/5.jpg",
      desc: "сухе вино, виготовленно в Новій Зеландії",
      storage: "",
      price: "120 UAH",
      weight: "100г",
      categoria: "Червоні Вина",
      id: 6,
    },
  },
  "Ігристі Вина": {
    1: {
      name: "ВИНО ІГРИСТЕ CAVA JAUME SERRA",
      photo: "alcohol/shampagne/1.jpeg",
      desc: "",
      storage: "",
      price: "550 UAH",
      weight: "750г",
      categoria: "Ігристі Вина",
      id: 1,
    },
    2: {
      name: "ВИНО ІГРИСТЕ JAUME SERRA CAVA BRUT ROSE",
      photo: "alcohol/shampagne/2.jpeg",
      price: "550 UAH",
      weight: "750г",
      categoria: "Ігристі Вина",
      id: 2,
    },
    3: {
      name: "ВИНО ІГРИСТЕ CHIARLI LAMBRUSCO",
      photo: "alcohol/shampagne/3.jpg",
      price: "440 UAH",
      weight: "750г",
      categoria: "Ігристі Вина",
      id: 3,
    },
    4: {
      name: "ПРОСЕККО",
      photo: "alcohol/shampagne/4.jpeg",
      price: "46 UAH",
      weight: "100г",
      categoria: "Ігристі Вина",
      id: 4,
    },
  },
  Джин: {
    1: {
      name: "BEEFEATER",
      photo: "alcohol/gin/1.jpeg",
      price: "85 UAH",
      weight: "50г",
      categoria: "Джин",
      id: 1,
    },
    2: {
      name: "BEEFEATER PINK STRAWBERRY",
      photo: "alcohol/gin/2.jpeg",
      price: "95 UAH",
      weight: "50г",
      categoria: "Джин",
      id: 2,
    },
  },
  Коньяк: {
    1: {
      name: "СТАРИЙ КАХЕТТІ БРЕНДІ",
      photo: "alcohol/koniak/1.jpeg",
      price: "60 UAH",
      weight: "50г",
      categoria: "Коньяк",
      id: 1,
    },
    2: {
      name: "МЕТАКСА",
      photo: "alcohol/koniak/2.jpeg",
      price: "90 UAH",
      weight: "50г",
      categoria: "Коньяк",
      id: 2,
    },
    3: {
      name: "КРАФТОВИЙ ОДЕСЬКИЙ",
      photo: "alcohol/koniak/3.jpeg",
      price: "50 UAH",
      weight: "50г",
      categoria: "Коньяк",
      id: 3,
    },
  },
  "Крафтові Настоянки": {
    1: {
      name: "наша бехеровка",
      photo: "alcohol/nastoyanki/1.jpg",
      price: "30 UAH",
      weight: "50г",
      categoria: "Коньяк",
      id: 1,
    },
    2: {
      name: "обліпиха з медом",
      photo: "alcohol/nastoyanki/2.jpg",
      price: "30 UAH",
      weight: "50г",
      categoria: "Коньяк",
      id: 2,
    },
    3: {
      name: "підступний цитрус",
      photo: "alcohol/nastoyanki/3.jpg",
      price: "30 UAH",
      weight: "50г",
      categoria: "Коньяк",
      id: 3,
    },
  },
  "Гарячі коктейлі": {
    1: {
      name: "Глінтвейн на білому груша - бузина",
      photo: "./q.png",
      price: "95 UAH",
      weight: "230г",
      categoria: "Гарячі коктейлі",
      id: 1,
    },
    2: {
      name: "Глінтвейн обліпиховий",
      photo: "./q.png",
      price: "95 UAH",
      weight: "230г",
      categoria: "Гарячі коктейлі",
      id: 2,
    },
    3: {
      name: "Глінтвейн червоний",
      photo: "./q.png",
      price: "95 UAH",
      weight: "230г",
      categoria: "Гарячі коктейлі",
      id: 3,
    },
    4: {
      name: "Глінтвейн червоний чорниця",
      photo: "./q.png",
      price: "95 UAH",
      weight: "230г",
      categoria: "Гарячі коктейлі",
      id: 4,
    },
    // 5: {
    //   name: "Грог грушевий",
    //   photo: "./q.png",
    //   price: "95 UAH",
    //   weight: "230г",
    //   categoria: "Гарячі коктейлі",
    //   id: 5,
    // },
    // 6: {
    //   name: "Грог чорна смородина",
    //   photo: "./q.png",
    //   price: "95 UAH",
    //   weight: "230г",
    //   categoria: "Гарячі коктейлі",
    //   id: 6,
    // },
  },
  "Холодні коктейлі": {
    1: {
      name: "A La Pino Colada",
      photo: "coctails/1.jpg",
      price: "140 UAH",
      weight: "250г",
      storage:
        "лікер кокос, Лікер персиковий, Сік Ананас, вершки, сироп Гренадін, Горілка Грейпфрут",
      categoria: "Холодні коктейлі",
      id: 1,
    },
    2: {
      name: "Pink Sour",
      photo: "coctails/2.jpg",
      price: "180 UAH",
      weight: "200г",
      storage: "Джин, сироп цукровий, Лимонний фреш, Альбумін",
      categoria: "Холодні коктейлі",
      id: 2,
    },
    3: {
      name: "Апероль Sour",
      photo: "coctails/17.jpg",
      price: "180 UAH",
      weight: "200г",
      storage: "Джин, Апероль, сироп Кленовий, Лимонний фреш, Альбумін",
      categoria: "Холодні коктейлі",
      id: 3,
    },
    4: {
      name: "Апероль Шприц",
      photo: "coctails/4.jpeg",
      price: "145 UAH",
      weight: "350г",
      storage: "Апероль, Просеко, Апельсин, мінеральна вода",
      categoria: "Холодні коктейлі",
      id: 4,
    },
    5: {
      name: "Віскі Пунш",
      photo: "coctails/5.jpg",
      price: "115 UAH",
      weight: "200г",
      storage: "Віскі, вершки, молоко, мед",
      categoria: "Холодні коктейлі",
      id: 5,
    },
    6: {
      name: "Віскі Сауер",
      photo: "coctails/6.jpg",
      price: "170 UAH",
      weight: "200г",
      storage:
        "Віскі, сироп цукровий, Лимонний фреш, Альбумін, Настоянка Ангостура Біттер, оливки",
      categoria: "Холодні коктейлі",
      id: 6,
    },
    7: {
      name: "Кавер Маргарита",
      photo: "coctails/7.jpg",
      price: "150 UAH",
      weight: "200г",
      storage:
        "текіла, Тріпл Сек, Лимонний фреш, рослинне молоко, лікер кокос, Сік Сицилійський апельсин",
      categoria: "Холодні коктейлі",
      id: 7,
    },
    8: {
      name: "Кавовий лайт",
      photo: "coctails/8.jpg",
      price: "150 UAH",
      weight: "150г",
      storage: "Горілка, кава, Baileys",
      categoria: "Холодні коктейлі",
      id: 8,
    },
    9: {
      name: "Кловер клаб Sour",
      photo: "coctails/9.jpg",
      price: "170 UAH",
      weight: "200г",
      storage: "Джин, сироп Суниця, Лимонний фреш, Альбумін",
      categoria: "Холодні коктейлі",
      id: 9,
    },
    10: {
      name: "Між простинями",
      photo: "coctails/10.jpg",
      price: "130 UAH",
      weight: "150г",
      storage: "Бренді, Лікер Мигдальний, Просеко",
      categoria: "Холодні коктейлі",
      id: 10,
    },
    11: {
      name: "Мохіто",
      photo: "coctails/11.jpg",
      price: "145 UAH",
      weight: "300г",
      storage: "Лайм, М'ята, цукор тростинний, Ром, мінеральна вода",
      categoria: "Холодні коктейлі",
      id: 11,
    },
    12: {
      name: "Олень на балконі 2.0",
      photo: "coctails/12.jpg",
      price: "150 UAH",
      weight: "300г",
      storage: "Лікер Єгермайстер, Сік Апельсин, сироп Гренадін",
      categoria: "Холодні коктейлі",
      id: 12,
    },
    13: {
      name: "Рідкий чізкейк",
      photo: "coctails/13.jpg",
      price: "130 UAH",
      weight: "150г",
      storage:
        "Горілка, Тріпл Сек, сироп цукровий, сироп Ванільний, вершки, Сир маскарпоне",
      categoria: "Холодні коктейлі",
      id: 13,
    },
    14: {
      name: "Текіла Мімоза",
      photo: "coctails/14.jpg",
      price: "160 UAH",
      weight: "150г",
      storage: "текіла, Лимонний фреш, мед, Сік Грейпфрут, Просеко",
      categoria: "Холодні коктейлі",
      id: 14,
    },
    15: {
      name: "Тьотя Роза",
      photo: "coctails/15.jpg",
      price: "100 UAH",
      weight: "350г",
      storage:
        "вино, сироп Суниця, сироп Роза, Настоянка Ангостура Біттер, мінеральна вода",
      categoria: "Холодні коктейлі",
      id: 15,
    },
    16: {
      name: "Фьючер",
      photo: "coctails/16.jpg",
      price: "150 UAH",
      weight: "350г",
      storage: "Горілка, Сік Яблуко, огірок, Розмарин, медове віскі",
      categoria: "Холодні коктейлі",
      id: 16,
    },
    17: {
      name: "Хот леді",
      photo: "shots/3.jpg",
      price: "110 UAH",
      weight: "80г",
      storage: "Лікер Крем де Кафе, Baileys, кава, Капітан Морган голд",
      categoria: "Холодні коктейлі",
      id: 17,
    },
    18: {
      name: "Цитрусова Екстазія",
      photo: "./q.png",
      price: "140 UAH",
      weight: "250г",
      storage: "",
      categoria: "Холодні коктейлі",
      id: 18,
    },
  },
  Шоти: {
    1: {
      name: "Зелені хмари",
      photo: "shots/1.jpg",
      price: "99 UAH",
      weight: "60г",
      storage: "Самбука, Baileys, Абсент, Лікер Блю Кюрасао",
      categoria: "Шоти",
      id: 1,
    },
    2: {
      name: "Ірландські друзі",
      photo: "shots/2.jpg",
      price: "99 UAH",
      weight: "60г",
      storage: "сироп, Baileys, Тріпл Сек, Віскі",
      categoria: "Шоти",
      id: 2,
    },
    4: {
      name: "Шалений пес",
      photo: "shots/4.jpg",
      price: "99 UAH",
      weight: "60г",
      storage: "сироп, Горілка Абсолют грейпфрут, Табаско",
      categoria: "Шоти",
      id: 4,
    },
    5: {
      name: "шот 'Зелений мексиканець'",
      photo: "shots/5.jpg",
      price: "99 UAH",
      weight: "60г",
      storage: "лікер Пізан, Лимонний фреш, текіла",
      categoria: "Шоти",
      id: 5,
    },
  },
};
